import styled, { css } from 'styled-components'

import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Container = styled.div`
  display: block;
`

export const Dropdown = styled.div<{
  $fluid?: boolean
  $maxWidth: number | string
}>`
  position: relative;
  z-index: 10;
  background: var(--bg-primary);
  padding: var(--space-200) 0;
  color: var(--text-primary);
  width: 100%;
  border-radius: var(--radius-brand);

  &::after {
    display: block;
    content: '';
    position: absolute;
    height: var(--space-1200);
    width: 100%;
    top: 100%;
    background: var(--bg-primary);
  }

  ${mediaQueries.tablet} {
    border: 1px solid var(--border-secondary);
    padding: var(--space-100);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);

    &::after {
      display: none;
    }

    ${(props) =>
      props.$fluid
        ? css`
            width: 100%;
          `
        : css`
            max-width: ${props.$maxWidth}px;
          `}
  }
`

export const Options = styled.div<{
  $maxHeight?: number
}>(
  ({ $maxHeight }) => css`
    ${$maxHeight &&
    css`
      max-height: ${$maxHeight}px;
      overflow-y: scroll;

      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `};
  `,
)
